<template>
    <div id="page-box">
      <!-- <button @click=' isAdmin= !isAdmin '>{{ isAdmin?"관리자":"일반인"}}</button> -->
        <transition name="slide-fade">
            <sb-section :page='page' :key='page' :data='contents' v-if='!isLoading'
              :isAdmin='isAdmin' />
            <div v-else class="loading">
              <i class="fa fa-spinner fa-5x fa-spin" aria-hidden="true"></i> &nbsp;&nbsp;&nbsp;&nbsp;
              <h2>Now Loading</h2>
              <a href="http://incheon.devs.co.kr">
                <img src="/images/bn.jpg">
              </a>
            </div>
        </transition>
    </div>
</template>

<script>
// import Axios from 'axios';
import Section from './Section.vue';
import section01 from '../../assets/section01.js';
import section02 from '../../assets/section02.js';
import section03 from '../../assets/section03.js';
import section04 from '../../assets/section04.js';
import section05 from '../../assets/section05.js';
import section06 from '../../assets/section06.js';
import section07 from '../../assets/section07.js';
import section91 from '../../assets/section91.js';
import section92 from '../../assets/section92.js';


export default {
    name: 'sb-contents',
    components: {
        'sb-section': Section,
    },
    props: {
        menuShow: { type: Boolean },
    },
    data(){
        return {
            isDevMode: false,
            isAdmin: false,
            isLoading: false,
            page: this.$route.params.no,
            contents: null,
        }
    },
    methods: {
        getContents(page){
            this.isLoading = true;
            setTimeout( ()=>{
                switch (page) {
                    case "01": this.contents = section01; break;
                    case "02": this.contents = section02; break;
                    case "03": this.contents = section03; break;
                    case "04": this.contents = section04; break;
                    case "05": this.contents = section05; break;
                    case "06": this.contents = section06; break;
                    case "07": this.contents = section07; break;
                    case "91": this.contents = section91; break;
                    case "92": this.contents = section92; break;
                }
                this.isLoading = false;
            }, 150);
            // const url = `./data/section${page}.json`;
            // this.isLoading = true;
            // Axios.get(url).then(response=>{ // console.log(response.data);
            //     this.contents = response.data;
            //     this.isLoading = false;
            // }).catch(error=>{
            //     this.contents = {error: JSON.stringify(error) };
            //     this.isLoading = false;
            // });
        }
    },
    // @lifecycle
    created(){
        let url = window.location.href;
        if( url == undefined || url == null ) url = document.URL;
        this.isDevMode = url.startsWith('http://localhost:80');
        // 페이지 읽어오기
        this.getContents(this.page);
    },
    // @lifecycle for vue-router
    beforeRouteUpdate (to, from, next) {        
        this.page = to.params.no;
        this.getContents(this.page);
        next();
    }
}
</script>

<style>
#page-box {
  width: 100%;
  position: absolute;
  background-color: #efe;
  margin-top: 66px;
  min-height: 90vh;
  overflow-x: hidden;
  z-index: 10;
}

#page-box .loading{
  text-align: center;
  padding-top: 100px;
}
#page-box .loading h2,
#page-box .loading .fa-spin{
  color: #006969;
}

.page {
  border: 1px solid #cccccc;
  background-color: #ffffff;
  min-width: 480px;
  width: 80%;
  margin: 50px auto 80px auto;
  padding: 16px;
  transition: .2s;
}
.page.menu-hide {
  width: 90%;
}
.page p{
  line-height: 2em;
}
.page .hint {
  border: solid 1px #dddddd;
  padding: 0 8px;
  font-size: 0.9em;
}
.page .codesites {
  font-size: 2em;
  color: #777777;
}
.page .codesites a {
  color: #42b983;
}


.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .2s ease;
}
.slide-fade-enter{
  transform: translateX(150%);
}
.slide-fade-leave-to{
  transform: translateX(-150%);
}
</style>
